export default __webpack_public_path__ + "6e07dd901c3a14f436bed45f652befac.jpg";